import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e944cf9"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "id-token:", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "access-token:", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "refresh-token:", -1))

import { computed } from 'vue';
import { jwt2String } from '@/services/OidcService';

// eslint-disable-next-line

export default /*#__PURE__*/_defineComponent({
  __name: 'TokensDetails',
  props: {
    idToken: null,
    accessToken: null,
    refreshToken: null
  },
  setup(__props: any) {

const props = __props as { idToken?: string, accessToken?: string, refreshToken?: string };



const idTokenJson = computed(() => jwt2String(props.idToken));
const accessTokenJson = computed(() => jwt2String(props.accessToken));
const refreshTokenJson = computed(() => jwt2String(props.refreshToken));


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("pre", null, _toDisplayString(_unref(idTokenJson)), 1),
    _hoisted_2,
    _createElementVNode("pre", null, _toDisplayString(_unref(accessTokenJson)), 1),
    _hoisted_3,
    _createElementVNode("pre", null, _toDisplayString(_unref(refreshTokenJson)), 1)
  ]))
}
}

})